import * as yup from "yup";

export const TIRE_SET_TIRE_EDIT_FORM_SCHEMA = yup.object().shape({
  tires: yup
    .array()
    .of(yup.object())
    .min(4, "Set mora sadržavati 4 gume")
    .max(4, "Set može sadržavati maksimalno 4 gume")
    .test(
      "same-brand-per-axle",
      "Gume na istoj osovini moraju imati istog proizvođača",
      (tires) => {
        if (!tires || tires.length === 0) return true;

        // Grupiraj po dimenzijama (width-height-radius)
        const groups = new Map<string, any[]>();
        for (const tire of tires) {
          const t = tire as any;
          const key = `${t.width}-${t.height}-${t.radius}`;
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key)!.push(t);
        }

        // Provjeri da svaka grupa ima istog proizvođača
        for (const group of groups.values()) {
          const manufacturers = new Set(
            group.map((t) => t.tireManufacturer?.id).filter(Boolean)
          );
          if (manufacturers.size > 1) return false;
        }

        return true;
      }
    )
    .required("Molimo Vas dodajte gume u set"),
});
